import { Component, Input, OnInit } from '@angular/core';
import { NzImage, NzImageService } from 'ng-zorro-antd/image';
import { CROOBER_IMAGES_PROXY } from 'src/app/const';

@Component({
  selector: 'app-croober-images',
  templateUrl: './croober-images.component.html',
  styleUrls: ['./croober-images.component.scss'],
})
export class CrooberImagesComponent implements OnInit {
  @Input() selectedImageIndex: number = null;
  @Input() images: string[] = [];
  @Input() thumbnails: string[] = [];

  galleryImages: NzImage[];

  constructor(private gallery: NzImageService) {}

  ngOnInit() {
    if (this.images.length) {
      this.selectedImageIndex = this.images.length ? 0 : null;
      this.galleryImages = this.images.map((x) => ({
        // src: x?.replace(/https:\/\/img\d.croooober.com/, CROOBER_IMAGES_PROXY),
        src: x,
      }));
    }
  }

  openImage(index: number) {
    this.gallery.preview(this.galleryImages).switchTo(index);
  }

  select(index: number): void {
    this.selectedImageIndex = index;
  }
}
